export enum LoanApplicationStatus {
    ApplicationInProgress = 1,
    ApplicationCompleted = 2,
    CamInProgress = 3,
    CamCompleted = 4,
    OfferLetterGenerationInProgress = 5,
    OfferLetterGenerationCompleted = 6,
    RelationshipManagerOverLetterReviewInProgress = 7,
    RelationshipManagerOverLetterReviewCompleted = 8,
    AvailmentInProgress = 9,
    AvailmentCompleted = 10,
    LoanBookingInProgress = 11,
    LoanBookingCompleted = 12
}